import { PrognosisData } from '@typings/Patients';
import { ApiResponse, ListApiResponse } from '@typings/ApiResponse';
import { axiosIns } from './index';

const getPronosisLogs = async (
  slug: string,
  page: number,
  limit: number
): Promise<ApiResponse<ListApiResponse<PrognosisData>>> => {
  const response = await axiosIns.get(`carehome/prognosis/${slug}`, {
    params: {
      page,
      limit,
    },
  });
  return response.data;
};

export default getPronosisLogs;
